import { visible } from "@escapio/shared/event/visibility-observer";
import {
	trackContentInteraction,
	trackImpression,
} from "../../tracker/EventTracker";
import { pageTypeName } from "@escapio/portal/state/pageType";

customElements.define(
	"esc-impression-interaction-tracker",
	class extends HTMLElement {
		async connectedCallback() {
			await visible(this, 0, 100);

			const params = ["name", "piece", "target"].map(attr => this[attr]);
			trackImpression(...params);
			this.abortController = new AbortController();
			const selector =
				this.getAttribute("interaction-targets-selector") ||
				"a, button:not(:disabled)";
			this.querySelectorAll(selector).forEach(node =>
				node.addEventListener(
					"click",
					() => trackContentInteraction(...params),
					{ signal: this.abortController.signal },
				),
			);
		}

		disconnectedCallback() {
			this.abortController?.abort();
		}

		get name() {
			// If the element has defined the auto-name property, we set the
			// name according to the page type.
			if (this.hasAttribute("auto-name")) {
				return pageTypeName;
			}

			return this.getAttribute("content-name") || undefined;
		}

		get piece() {
			return this.getAttribute("content-piece") || undefined;
		}

		get target() {
			return this.getAttribute("content-target") || undefined;
		}
	},
);
